import React from 'react';
import { Card, CardContent } from './ui/card';
import { Scissors, Award, Shield, Sparkles, Clock, MapPin, Armchair, CheckCircle } from 'lucide-react';
import { services, whyChooseUs } from '../mock';

const Services = () => {
  const iconMap = {
    0: Scissors,
    1: Award,
    2: Shield,
    3: Sparkles,
    4: Clock,
    5: MapPin,
    6: Armchair,
    7: CheckCircle
  };

  return (
    <section id="services" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-[#0B0B0B] mb-4 font-playfair">Premium Services</h2>
          <div className="w-24 h-1 bg-[#C9A227] mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">Comprehensive grooming services crafted for the modern gentleman</p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24">
          {services.map((service) => (
            <Card key={service.id} className="group hover:shadow-2xl transition-all duration-300 border-0 bg-white hover:scale-105 overflow-hidden">
              <CardContent className="p-8">
                <div className="mb-6">
                  <div className="w-16 h-16 bg-black rounded-full flex items-center justify-center mb-4 group-hover:bg-[#C9A227] transition-colors duration-300">
                    <Scissors className="w-8 h-8 text-[#C9A227] group-hover:text-black transition-colors duration-300" strokeWidth={1.5} />
                  </div>
                  <h3 className="text-2xl font-bold text-[#0B0B0B] mb-2 font-playfair">{service.name}</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                </div>
                <div className="flex items-center justify-between border-t border-gray-200 pt-4">
                  <div>
                    <p className="text-sm text-gray-500 uppercase tracking-wide">Starting from</p>
                    <p className="text-2xl font-bold text-[#C9A227]">{service.price}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-gray-500 uppercase tracking-wide">Duration</p>
                    <p className="text-lg font-semibold text-[#0B0B0B]">{service.duration}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Why Choose Us Section */}
        <div className="bg-[#0B0B0B] -mx-4 px-4 md:mx-0 md:rounded-2xl py-16">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 font-playfair">Why Choose Mark's Barber</h2>
            <div className="w-24 h-1 bg-[#C9A227] mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {whyChooseUs.map((item, index) => {
              const IconComponent = iconMap[index] || CheckCircle;
              return (
                <div key={item.id} className="text-center p-6 rounded-lg hover:bg-white/5 transition-colors duration-300">
                  <div className="flex justify-center mb-4">
                    <div className="w-14 h-14 bg-[#C9A227] rounded-full flex items-center justify-center">
                      <IconComponent className="w-7 h-7 text-black" strokeWidth={1.5} />
                    </div>
                  </div>
                  <h3 className="text-lg font-bold text-white mb-2">{item.title}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">{item.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;